import React, {useState} from "react";
import {Box, Chip, Collapse, IconButton, Stack, TableCell, TableRow, Typography} from "@mui/material";
import {dispatch} from "../../redux/store";
import {getAllLineStationsByLineIds} from "../../redux/slices/lineStations";
import Iconify from "../../components/Iconify";
import moment from "moment";
import {getTripOperationalIntervalApi} from "../../api/trip";
import {formatOperationalDays} from "../../helper/operationalInterval";

export default function DepartureFromSpotTableRow({row, openRowId, setOpenRowId, index}) {
    const {lineName, operatorName, departureTime,arrivalTime, printText, lineId, tripId, canceledNote} = row;
    const [extraData, setExtraData] = useState(null);
    const [operationalInterval, setOperationalInterval] = useState(undefined);

    const isOpen = openRowId === index;
    const daysLabel = operationalInterval ? formatOperationalDays(operationalInterval) : "";
    const showDayLegend = /[1-7]/.test(daysLabel);

    const handleExpandClick = async () => {
        if (isOpen) {
            setOpenRowId(null);
        } else {
            setOpenRowId(index);
            if (!extraData) {
                try {
                    dispatch(getAllLineStationsByLineIds([lineId])).then(({payload}) => {
                        if (payload?.data) {
                            const arr = extractStationNames(payload.data)
                            setExtraData(arr);
                        }
                    });
                } catch (error) {
                    console.error("Failed to fetch extra data", error);
                }
            }
            if (operationalInterval === undefined) {
                if (tripId) {
                    getTripOperationalIntervalApi(tripId)
                        .then(({data}) => setOperationalInterval(data || null))
                        .catch((error) => {
                            console.error("Failed to fetch operational interval", error);
                            setOperationalInterval(null);
                        });
                } else {
                    setOperationalInterval(null);
                }
            }
        }
    };

    return (
        <>
            <TableRow hover>
                <TableCell align="left">{printText || lineName}</TableCell>
                <TableCell align="left">{operatorName}</TableCell>
                <TableCell align="left">
                    {departureTime ? moment.utc(departureTime).format("HH:mm") : "/"}
                </TableCell>
                <TableCell align="left">
                    {arrivalTime ? moment.utc(arrivalTime).format("HH:mm") : "/"}
                </TableCell>
                <TableCell>
                    <Typography textAlign="center" variant="subtitle2"
                                color={canceledNote ? "darkred" : null}>{canceledNote ? canceledNote : "/"}</Typography>
                </TableCell>
                <TableCell>
                    <IconButton onClick={handleExpandClick}>
                        {isOpen ? <Iconify icon="eva:arrow-ios-upward-fill"/> :
                            <Iconify icon="eva:arrow-ios-downward-fill"/>}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={4}>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap"
                                   sx={{mb: 1}}>
                                <Typography variant="subtitle2">Dani polaska:</Typography>
                                {operationalInterval === undefined ? (
                                    <Typography variant="body2" color="text.secondary">učitavanje…</Typography>
                                ) : operationalInterval ? (
                                    <>
                                        {operationalInterval.name && (
                                            <Typography variant="body2">{operationalInterval.name}</Typography>
                                        )}
                                        {daysLabel && (
                                            <Chip
                                                size="small"
                                                color="info"
                                                variant="outlined"
                                                label={daysLabel}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <Typography variant="body2" color="text.secondary">nije definisano</Typography>
                                )}
                                {showDayLegend && (
                                    <Typography variant="caption" color="text.disabled">
                                        (1=Pon, 2=Uto, 3=Sre, 4=Čet, 5=Pet, 6=Sub, 7=Ned)
                                    </Typography>
                                )}
                            </Stack>
                            {extraData ? (
                                <div>
                                    {extraData.map((data, index) => (
                                        <Chip
                                            key={index}
                                            label={data}
                                            color="primary"
                                            variant="outlined"
                                            style={{ margin: '4px' }}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <p>Trenutak...</p>
                            )}

                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

function extractStationNames(dataArray) {
    return dataArray.map(item => item.station.name);
}

